import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: resolve => require(["../views/home/Home.vue"], resolve)
  },
  {
    path: "/articles/:articleId",
    component: resolve => require(["../views/article/Article.vue"], resolve)
  },
  {
    path: "/archives",
    component: resolve => require(["../views/archive/Archive.vue"], resolve),
    meta: {
      title: "归档"
    }
  },
  // {
  //   path: "/albums",
  //   component: resolve => require(["../views/album/Album.vue"], resolve),
  //   meta: {
  //     title: "相册"
  //   }
  // },
  {
    path: "/albums/:albumId",
    component: resolve => require(["../views/album/Photo.vue"], resolve)
  },
  {
    path: "/tags",
    component: resolve => require(["../views/tag/Tag.vue"], resolve),
    meta: {
      title: "标签"
    }
  },
  {
    path: "/categories",
    component: resolve => require(["../views/category/Category.vue"], resolve),
    meta: {
      title: "分类"
    }
  },
  {
    path: "/categories/:categoryId",
    component: resolve => require(["../views/article/ArticleList.vue"], resolve)
  },
  {
    path: "/tags/:tagId",
    component: resolve => require(["../views/article/ArticleList.vue"], resolve)
  },
  {
    path: "/links",
    component: resolve => require(["../views/link/Link.vue"], resolve),
    meta: {
      title: "友链列表"
    }
  },
  {
    path: "/chat",
    component: resolve => require(["../views/about/About.vue"], resolve),
    // meta: {
    //   title: "聊天"
    // }
  },
  {
    path: "/message",
    component: resolve => require(["../views/message/Message.vue"], resolve),
    meta: {
      title: "留言板"
    }
  },
  // {
  //   path: "/user",
  //   component: resolve => require(["../views/user/User.vue"], resolve),
  //   meta: {
  //     title: "个人中心"
  //   }
  // },
  {
    path: "/paper",
    component: resolve => require(["../views/paper/PaperList.vue"], resolve)
  },
  {
    path: "/paper",
    component: resolve => require(["../views/paper/Paper.vue"], resolve)
  },
  {
    path: "/callback/qq",
    component: resolve => require(["../components/OauthLogin.vue"], resolve)
  },
  {
    path: "/callback/gitee",
    component: resolve => require(["../components/OauthLogin.vue"], resolve)
  },
  {
    path: "/callback/weibo",
    component: resolve => require(["../components/OauthLogin.vue"], resolve)
  },
  {
    path: "/book",
    component: resolve => require(["../views/book/Book.vue"], resolve),
    meta: {
      title: "阅读"
    }
  },
  {
    path: "/book-img/:bookId",
    component: resolve => require(["../views/book/BookImgList.vue"], resolve)
  },
  {
    path: "/book-pdf/:bookId",
    component: resolve => require(["../views/book/BookListpdf.vue"], resolve)
  },
  {
    path: "/memo",
    component: resolve => require(["../views/memo/index.vue"], resolve)
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
